<template>
  <span class="input-label">
    <label v-if="!required" class="input-label__overline">
      {{ optionalLabel }}
    </label>
    <label class="input-label__label">
      {{ label }}
    </label>
  </span>
</template>

<script>
import BaseComponent from "../../BaseComponent";

/**
 * @group Inputs - parts
 * Label above the input, this also includes an optional label.
 * This gives the user an indication of what they have to fill in into the input they are handling.
 */

export default {
  name: "InputLabel",
  mixins: [BaseComponent],
  props: {
    // The Label for the input
    label: {
      type: String,
      required: true,
    },
    // If this is set to true, an optional tag is shown, which indicates the input is not required.
    required: {
      type: Boolean,
      default: false,
    },
    optionalLabel: {
      type: String,
      default: "Optional",
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../style_variables/style_variables.scss";
.input-label__overline {
  @extend %body2_style;
  font-size: 0.75em;
  color: $blue;
  display: block;
}
.input-label__label {
  @extend %headline6_style;
  font-weight: 600;
  color: $grey_mineshaft;
}
</style>
